import React from 'react';
import { FormGenerator } from '@hwm/ui-lib';
import { SiteListPreferencesModel } from '@shared/models';
import { useFormikContext } from 'formik';
import { siteListPreferencesFieldsConfiguration } from './SiteListPreferences.utils';

export const SiteListPreferences: React.FC = () => {
  const formikProps = useFormikContext<SiteListPreferencesModel>();

  return (
    <div>
      <FormGenerator
        {...formikProps}
        fieldsConfiguration={siteListPreferencesFieldsConfiguration}
        formDisabled={false}
        newEditableLook
        dataTestId="preferences-sitelist-form"
      />
    </div>
  );
};
